import script from "./Address.vue?vue&type=script&lang=ts&setup=true"
export * from "./Address.vue?vue&type=script&lang=ts&setup=true"

import "./Address.vue?vue&type=style&index=0&id=47f9e41b&scoped=true&lang=less"
import "./Address.vue?vue&type=style&index=1&id=47f9e41b&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f9e41b"]])

export default __exports__